export default __webpack_public_path__ + "static/media/who-we-are-img-08.223f8283.jpg";